{
  "close": "Close dialog"
}
